import { render, staticRenderFns } from "./UploadedReportsGallery.vue?vue&type=template&id=bb3a2240&scoped=true&"
import script from "./UploadedReportsGallery.vue?vue&type=script&lang=js&"
export * from "./UploadedReportsGallery.vue?vue&type=script&lang=js&"
import style0 from "./UploadedReportsGallery.vue?vue&type=style&index=0&id=bb3a2240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3a2240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb3a2240')) {
      api.createRecord('bb3a2240', component.options)
    } else {
      api.reload('bb3a2240', component.options)
    }
    module.hot.accept("./UploadedReportsGallery.vue?vue&type=template&id=bb3a2240&scoped=true&", function () {
      api.rerender('bb3a2240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickEHR/UploadedReportsGallery.vue"
export default component.exports